import { Auth, API } from 'aws-amplify';

const requestHeaders = async () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `${(await Auth.currentSession())
      .getAccessToken()
      .getJwtToken()}`
  };
};

const updateUserAttributes = async function(
  { dispatch, getters, commit },
  { username, attrName, attrValue }
) {
  if (!username) {
    throw Error('ERROR::ACCOUNT_SIGN_IN: No parameters provided.');
  }
  let path = '/updateUserAttributes';
  try {
    let payload = {
      body: {
        username,
        attrName,
        attrValue
      },
      headers: await requestHeaders()
    };
    let req = await API.post('AdminQueries', path, payload);
    if (req.message.split(' ')[0] === 'User:') {
      return req.message;
    }
    throw Error('Error enabling user', req);
  } catch (error) {
    throw Error(error);
  }
};

export default updateUserAttributes;
